export default "__VITE_ASSET__9AL5JmRJ__"